import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import IconButton from '@mui/material/IconButton';
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import MuiAccordion from '@mui/material/Accordion';
import Divider from '@mui/material/Divider';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Grid from '@mui/material/Grid';
import FormInputText from '../common/Forms/FormTextField';
import FormControl from '@mui/material/FormControl';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Checkbox from '@mui/material/Checkbox';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';

export const DataGridContainer = styled(Box)`
  height: 60vh;
  margin-top: 10px;
`;

export const SearchBarQuickFilter = styled(TextField)`
  background-color: #ffffff;
  border: 2px solid #000000;
  padding: 0px 5px;
  margin-bottom: 5px;
`;

export const ButtonIcon = styled(IconButton)`
  background-color: transparent;
`;

export const SearchBar = styled(Box)`
  padding: 0.5px;
  padding-bottom: 0px;
  background-color: #747070;
`;

export const Accordion = styled((props) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  '&:not(:last-child)': {
    borderBottom: 0,
  },
  '&:before': {
    display: 'none',
  },
}));

export const AccordionSummary = styled((props) => (
  <MuiAccordionSummary
    expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: '0.9rem' }} />}
    {...props}
  />
))(({ theme }) => ({
  backgroundColor:
    theme.palette.mode === 'dark'
      ? 'rgba(255, 255, 255, .05)'
      : 'rgba(0, 0, 0, .03)',
  flexDirection: 'row-reverse',
  '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
    transform: 'rotate(90deg)',
  },
  '& .MuiAccordionSummary-content': {
    marginLeft: theme.spacing(1),
  },
}));

export const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: theme.spacing(2),
  borderTop: '1px solid rgba(0, 0, 0, .125)',
}));

export const ContentTitle = styled(Grid)`
  padding: 5px 0px;
  align-items: center;
`;

export const RightGrid = styled(Grid)`
  display: flex;
  align-items: center;
  padding-top: 10px;
  margin-bottom: 10px;
`;

export const IconArrowBack = styled(ArrowBackIcon)`
  color: #262626;
`;
//ButtonGrid
export const AutoCompleteText = styled(TextField)`
  .MuiOutlinedInput-root {
    padding: 3px;
    padding-right: 5px !important;
  }
`;

export const ButtonGrid = styled(Grid)`
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;
`;

export const DialogDivider = styled(Divider)`
  margin: 0px 40px;
  border-color: #747070;
`;

export const DividerGrid = styled(Box)`
  padding: 0px 0px 20px 0px;
`;

export const GridDivider = styled(Divider)`
  margin-left: 0px;
  margin-right: 0px;
  border-color: #747070;
`;

export const CommonDropDownStyle = styled(FormControl)`
  display: flex;
  margin-bottom: 16.5px;
`;

export const MiniDropDownStyle = styled(FormControl)`
  display: flex;
  margin-bottom: 4.5px;
`;

export const CMPText = styled(TextField)`
  .MuiOutlinedInput-input {
    padding: 2px 8px;
    padding-right: 8px !important;
  }
  margin-bottom: 6.5px;
`;

export const FormInputStyled = styled(FormInputText)`
  margin-bottom: 0px;
`;
export const FullDivider = styled(Divider)`
  margin: 10px 0px;
  border-color: #747070;
`;

export const ParticipantCommentGrid = styled(Grid)`
  margin-top: 20px;
`;

export const VerifyWeekTypo = styled(Typography)`
  padding-bottom: 6px;
`;

export const TypographyLink = styled(Typography)`
  width: 100%;
  cursor: pointer;
  font-size: 15px;
  color: #0000ff;
`;

export const FormHeading = styled(Grid)`
  padding: 5px 0px;
  align-items: flex-start;
  margin-top: 50px;
  margin-bottom: -25px;
`;

export const FormContentTitle = styled(Grid)`
  display: flex;
  align-items: center;
`;

export const LinkTypography = styled(Typography)`
  width: 100%;
  cursor: pointer;
  font-size: 15px;
  color: #0000ff;
  padding: 15px 0px;
`;

export const VerificationDialogLoadingBox = styled(Box)`
  height: 95vh;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const TransportTitle = styled(Typography)`
  margin-bottom: 10px;
  margin-top: -8px;
`;

export const Form = styled(Box)`
  padding: 10px 40px;
`;

export const GridForm = styled(Grid)`
  padding: 10px 40px;
  margin-top: 0px;
`;

export const CmpTitle = styled(Typography)`
  margin-bottom: 5px;
`;

export const GridCenter = styled(Grid)`
  justify-content: center;
`;

export const PdfGrid = styled(Grid)`
  display: block;
  flex-direction: column;
`;

export const GridPdfWrapper = styled(Grid)`
  margin-bottom: 16px;
  flex-direction: column;
  width: 1650px;
`;

export const PrintPage = styled(Box)({
  '@media print': {
    //pageBreakAfter: 'always',
    //height: '100vh',
    //margin: '0 !important',
    //padding: '0 !important',
    //overflow: 'hidden'
  },
});

export const PdfTitleTypography = styled(Typography)`
  margin: 8px 0px;
`;

export const PdfCheckBox = styled(Checkbox)`
  padding-left: 0px;
`;

export const PdfLeftGrid = styled(Grid)`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`;

export const RightButton = styled(Button)`
  margin-left: 8px;
`;

export const GridHeading = styled(Grid)`
  flex-direction: column;
  align-items: center;
`;

export const CheckBoxGrid = styled(Grid)`
  display: flex;
  align-items: center;
`;

export const BorderTableRow = styled(TableRow)`
  border: 2px solid;
`;

export const BorderTableCell = styled(TableCell)`
  border-right: 1px solid;
`;